// src/lib/api.ts
export interface BlogResponse {
    code: number;
    message: string;
    status: string;
    data: {
        page_no: number;
        per_page: number;
        total_records: number;
        blogs: BlogData[];
    };
}

export interface BlogData {
    blog_id: number;
    blog_title: string;
    blog_description: string;
    meta_description: string;
    blog_image: string;
    category: string;
    created_date: string;
    created_by: string;
}

export async function fetchBlogData(): Promise<BlogData[]> {
    try {
        const apiBaseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'https://sqxbonds-uat.exchange-data.co.in/api/';

        const res = await fetch(`${apiBaseUrl}/Common/AllBlogs`, {
            next: {
                revalidate: 10,
                tags: ['server-cache', 'blog-cache'], // 🔸 Shared tag for all fetches
            },
        });

        if (!res.ok) {
            throw new Error('Failed to fetch blog data');
        }

        const response: BlogResponse = await res.json();

        return response.data?.blogs || []; // Return just the blogs array
    } catch (error: unknown) {
        console.error(error instanceof Error ? error.message : 'An unknown error occurred');
        return [];
    }
}
